import { DropdownOption, mapToDropdownOptionArrayWithTextGetter } from 'components/final-form/dropdownUtils';
import { MessageSourceProps, withMessages } from "react-message-source";
import React, { Component } from 'react';
import axios, { CancelTokenSource } from 'axios';
import { GuarantorDto } from 'ts-types/api.types';
import { getGuarantorData, searchGuarantorsForInput } from 'services/guarantorServices';
import Select from 'components/final-form/Select';
import { Field } from 'react-final-form';
import { noop } from 'utils/functionUtils';

interface Props extends MessageSourceProps {
  guarantors: Array<DropdownOption>,
  guarantorId?: number,
  tariffType?: string,
  readOnly: boolean
}

interface State {
  guarantors: Array<DropdownOption>,
  cancelTokenSource: CancelTokenSource
}


class GuarantorDropdownSegment extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      guarantors: props.guarantors,
      cancelTokenSource
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {

    const {guarantorId} = this.props;
    const {cancelTokenSource} = this.state;

    if (prevProps.guarantorId === undefined && guarantorId) {
      getGuarantorData(guarantorId, cancelTokenSource)
          .then((response) => {

            const guarantor: DropdownOption = {
              key: guarantorId,
              text: response.description,
              value: guarantorId
            }

            this.setState({
              guarantors: [guarantor]
            })
          })
          .catch(noop)
    }
  }

  searchGuarantors = (search: string): Promise<Array<GuarantorDto>> => {
    const {cancelTokenSource} = this.state;
    const {tariffType} = this.props;
    return searchGuarantorsForInput(search, cancelTokenSource, 75, tariffType);
  };

  guarantorMapper = (response: Array<GuarantorDto>): Array<DropdownOption> => {
    return mapToDropdownOptionArrayWithTextGetter(response,
        (guarantor: GuarantorDto) => {
          const tariffType = guarantor.tariffType ? " - " + guarantor.tariffType : "";
          if (!guarantor.description) {
            return guarantor.bagNumber + tariffType;
          }
          if (!guarantor.bagNumber) {
            return guarantor.description + tariffType;
          }

          return `${guarantor.description} - ${guarantor.bagNumber}` + tariffType;
        });
  };

  render() {
    const {readOnly, getMessage} = this.props;
    const {guarantors} = this.state;

    return (
        <Field
            name='guarantorId'
            component={Select}
            placeholder={getMessage('guarantor')}
            options={guarantors}
            remoteSearch
            remoteSearchMethod={this.searchGuarantors}
            searchResultToOptionMapper={this.guarantorMapper}
            clearable
            fluid
            disabled={readOnly}
        />
    );
  }
}

export default withMessages(GuarantorDropdownSegment);
